/**
 * 패널 플래닝 사용자 알림 — GlobalAlert(commonAlert) 단일 경로
 */

/** @param {unknown} treeData */
export function countPanelPlanningArrays(treeData) {
  if (!Array.isArray(treeData)) {
    return 0;
  }
  return treeData.filter(node => node?.type === 'array').length;
}

/**
 * String 대상 Array 미지정 시 alert 본문
 * @param {(key: string) => string} t — vue-i18n $t
 * @param {unknown} treeData
 */
export function getStringDrawTargetRequiredAlertMessage(t, treeData) {
  if (countPanelPlanningArrays(treeData) === 0) {
    return t('panelPlanning.stringDrawTargetNoArrayAlert');
  }
  return t('panelPlanning.stringDrawTargetHintUnset');
}

/**
 * @param {import('vuex').Store<unknown>} store
 * @param {{ type?: string, message: string, timeout?: number }} payload
 */
export function dispatchPanelPlanningAlert(store, payload) {
  const type = payload.type || 'info';
  const message = payload.message || '';
  if (!message || !store?.dispatch) {
    return;
  }
  store.dispatch('commonAlert/addAlert', {
    type,
    message,
    timeout: payload.timeout ?? (type === 'error' ? 0 : 8000)
  });
}
